import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgComputerWarning(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M107.997 87.045c0 3.016-2.455 5.459-5.486 5.459H9.986c-3.031 0-5.486-2.443-5.486-5.46v-.559h103.497v.56Z"
        fill="#78B441"
      />
      <path
        d="M107.997 86.492v.56c0 3.015-2.455 5.458-5.486 5.458H84.957c-3.031 0-5.486-2.443-5.486-5.459v-.56h28.526ZM30.304 86.492h23.363v.962a2.05 2.05 0 0 1-2.058 2.047H32.361a2.05 2.05 0 0 1-2.057-2.047v-.962Z"
        fill="#599F40"
      />
      <path
        d="m31.45 86.485 8.776-47.512a5.484 5.484 0 0 1 5.397-4.47h65.391c3.429 0 6.014 3.091 5.397 6.449l-8.407 45.54H31.449v-.007Z"
        fill="#78B441"
      />
      <path
        d="m37.394 79.163 7.2-38.211a2.055 2.055 0 0 1 2.023-1.672h62.333a2.053 2.053 0 0 1 2.023 2.422l-7.2 38.212a2.055 2.055 0 0 1-2.023 1.672H39.417a2.053 2.053 0 0 1-2.023-2.423Z"
        fill="#fff"
      />
      <path d="M71.057 34.503h10.286l-.686 4.777H70.371l.686-4.777Z" fill="#599F40" />
      <path
        d="M75.857 38.181c.716 0 1.296-.577 1.296-1.29 0-.712-.58-1.289-1.296-1.289-.716 0-1.296.577-1.296 1.29 0 .712.58 1.29 1.296 1.29Z"
        fill="#0F172A"
      />
      <path
        d="M33.078 28.918 18.068 52.91c-2.088 3.333.404 7.592 4.435 7.592h30.02c4.03 0 6.522-4.259 4.433-7.592L41.94 28.918c-2.015-3.224-6.852-3.224-8.868 0h.007Z"
        fill="#FC0"
      />
      <path
        d="M39.418 53.305c0 1.043-.85 1.89-1.905 1.89a1.896 1.896 0 0 1-1.906-1.89c0-1.043.85-1.889 1.906-1.889 1.055 0 1.905.846 1.905 1.89ZM38.912 47.063l.506-10.269a1.907 1.907 0 1 0-3.811 0l.506 10.269a1.405 1.405 0 0 0 1.4 1.334 1.4 1.4 0 0 0 1.4-1.334ZM107.325 85.685a.8.8 0 1 1 0 1.6H12.914a.8.8 0 1 1 0-1.6h94.411Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgComputerWarning)
